// "ziggy" is an alias defined in webpack.mix.js. Eslint can't resolve this alias however.
// eslint-disable-next-line import/no-unresolved
import { route } from "ziggy";
import { formatHrefToPath, isCurrentVueRoute, isVueRoute } from "~/router/helpers";
/**
 * Router class for navigating throughout the application.
 */

export default class Navigator {
  static handleRedirectResponse(response) {
    const redirectPath = response?.data?.meta?.redirect;
    if (!redirectPath) return;

    Navigator.redirectPath(redirectPath);
  }

  static redirect(ziggyRoute) {
    window.location.replace(route(ziggyRoute));
  }

  static routerViewElementIsFound() {
    return document.querySelector("#router-view") !== null;
  }

  static ifVuePathNavigateToPath(path) {
    const isVueRouteBoolean = isVueRoute(path);

    if (isVueRouteBoolean && this.routerViewElementIsFound()) {
      this.navigateVuePath(path);
    }
    return isVueRouteBoolean && this.routerViewElementIsFound();
  }

  static redirectPath(path) {
    if (!this.ifVuePathNavigateToPath(path)) {
      window.location.replace(path);
    }
  }

  static navigate(ziggyPath, ziggyParams) {
    if (!this.ifVuePathNavigateToPath(ziggyPath)) {
      this.navigateVuePath(route(ziggyPath, ziggyParams));
    }
  }

  static navigatePath(path) {
    if (!this.ifVuePathNavigateToPath(path)) {
      window.location.href = (path);
    }
  }

  static openPath(path) {
    window.open(path, "_blank");
  }

  static navigateVuePath(path) {
    const formattedPath = formatHrefToPath(path);
    if (isCurrentVueRoute(formattedPath)) return;
    window.main?.$router?.push(formattedPath);
  }

  static back() {
    const history = window.main.$routerHistory;

    const previous = history.previous();

    if (!previous?.path) {
      this.navigatePath(route("dashboard"));
    } else {
      this.navigatePath(previous.path);
    }
  }
}
